
export default [
	{name: 'C++' , icon:'devicon-cplusplus-plain-wordmark' },
	{name: 'Java' , icon : 'devicon-java-plain' },
	{name: 'JS' , icon: 'devicon-javascript-plain' },
	{name: 'Express JS' , icon: 'devicon-express-original' },
	{name: 'Python', icon:'devicon-python-plain' },
	{name: 'Mongo DB' ,icon:'devicon-mongodb-plain' },
	{ name: 'My SQL',icon:'devicon-mysql-plain' },
	{name: 'React JS' , icon:'devicon-react-original' },
	{name: 'Vue JS',icon:'devicon-vuejs-plain' }
];
